import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactoService } from 'src/app/services/contacto.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { alertaConfirmacion, alertaConfirmacionHTML, basicAlert, basicAlertHTML, filtrarCoincidenciaArrayTransportista, obtenerFechaActual, obtenerFechaSeleccionada, openDescripcion, openObservacion, openReutilizar, setConfigTable, setConfigTableBuscador, timerOut } from 'src/app/shared/utils';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { objContactosFrm } from './contactos.model';
import { ContactoClase } from 'src/app/models/ContactoClase.model';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-contacto-frm',
  templateUrl: './contacto-frm.component.html',
  styleUrls: ['./contacto-frm.component.css']
})
export class ContactoFrmComponent implements OnInit {
  Paramcontactos = new objContactosFrm();
  objContacto = new objContactosFrm();

  public contacto: any = {};
  public checkActivo: boolean = false;
  public contactoClases: any[] = [];
  public clasesCombo: any[] = [];
  closeResult = '';
  public claseCodigos: any[] = [];
  public codClase: number = null;
  public desClase: string = '';
  public codCodigoClase: string = '';
  public desCodigoClase: string = '';
  public editar: boolean = false;
  public codInterlocutor: any;
  modalReference: any;


  @ViewChild('nomcont') nomcont: ElementRef;
  @ViewChild('id') id: ElementRef;
  public ParamsContactoClases = new ContactoClase();
  public codUsuario: string = '';
  public sessionInfo: any = null;

  constructor(
    private modalactiveService: NgbActiveModal,
    private spinnerService: SpinnerService,
    private contactoService: ContactoService,
    private modalService: NgbModal,
    private interlocutorService: InterlocutorService,
    private storageService: StorageService,

  ) { }

  ngOnInit(): void {
    console.log('dttooss')
    console.log(this.codInterlocutor)
    this.sessionInfo = JSON.parse(StorageService.getSession());
    this.codUsuario = this.sessionInfo.coduser;
 
    this.checkActivo = true;
    if (this.editar) {
      this.checkActivo = this.contacto.activo;
      this.openUpdateContactoCliente(this.contacto);
    }else{
      this.contacto.felicitacion =  obtenerFechaActual('YYYY-MM-DD')
    }

  }

  openUpdateContactoCliente(data: any) {
    this.interlocutorService.getGetByIdContactoInterlocutor(this.codInterlocutor, data.codcont).subscribe((response: any) => {
      console.log('editando as',response);
      
      this.objContacto.codContacto = response.body.codcont;
      this.objContacto.cargoContacto = response.body.cargo;
      this.objContacto.dirContacto = response.body.direccion;
      //this.objContacto.codContacto = response.body.factua;
      //this.objContacto.codContacto = response.body.fcreac;
      this.objContacto.hobbyContacto = response.body.hobby;
      this.objContacto.nomContacto = response.body.nomcont;
      this.objContacto.telfContacto = response.body.telefono;
      this.objContacto.activoContacto = response.body.activo;
      this.objContacto.correoContacto = response.body.correo;
      this.objContacto.felicitacion=response.body.felicitacion;

      this.contactoClases = response.body.clases;
     
    }, err => {
      console.log(err);
      if (err.status == 404) {
        this.spinnerService.activarLoading(false);
        basicAlert(err.error, 'warning', 'Aceptar', null, null);
      }
    })
  }


  _close() {
    this.modalactiveService.dismiss('canceling');
  }


  _success() {
    if (this.contacto.nomcont == undefined || this.contacto.nomcont == "") {
      basicAlert("El campo 'Nombre' es requerido.", 'warning', 'Aceptar');
      return;
    }
    this.contacto.activo = this.checkActivo;

    this.spinnerService.activarLoading(true);
    this.contactoService.insertContacto(this.contacto).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.modalactiveService.close(response.body);
    }, err => {
      this.spinnerService.activarLoading(false);
      console.log(err);
      if (err.status >= 500) {
        basicAlert('Servicio no disponible : contactoService', 'warning', 'Aceptar', null, null,);
      } else {
        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
      }
    })

  }

  _actualizar() {


    if (this.contacto.nomcont == "") {
      basicAlert("El campo 'Nombre' es requerido.", 'warning', 'Aceptar');
      return;
    }

    this.contacto.activo = this.checkActivo;

    this.spinnerService.activarLoading(true);
    this.contactoService.actualizar_contacto(this.contacto).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.modalactiveService.close({
        actualizado: true,
        contacto: response.body
      });
    }, err => {
      this.spinnerService.activarLoading(false);
      console.log(err);
      if (err.status >= 500) {
        basicAlert('Servicio no disponible : contactoService', 'warning', 'Aceptar', null, null,);
      } else {
        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
      }
    })
  }

  onChangeActivoContacto(isChecked: boolean) {
    this.checkActivo = isChecked;
  }

  onNexFocus(tipo: string) {
    if (tipo == 'nuevo') {
      timerOut(10).then((value: any) => {
        if (value) { this.nomcont.nativeElement.focus(); }
      })
    }
  }

  NuevaClase(content: string) {
    console.log('dttooss')
//console.log(this.codInterlocutormod)
    this.spinnerService.activarLoading(true);
    this.contactoService.getListClasesContacto().subscribe((response: any) => {
      console.log(response);
      this.clasesCombo = response.body;

      if (this.clasesCombo.length > 0) {

        this.NuevoModal(content);

        this.spinnerService.activarLoading(false);
      } else {
        basicAlert('No hay clases de contacto asignadas', 'warning', 'Aceptar', null, null);
        this.spinnerService.activarLoading(false);
      }
    }, err => {
      console.log(err);
      if (err.status == 404) {
        basicAlert(err.error, 'warning', 'Aceptar', null, null);
        this.spinnerService.activarLoading(false);
      }
    })
  }
  NuevoModal(content: string) {
    this.modalReference = this.modalService.open(content);
    this.spinnerService.activarLoading(true)
    this.modalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    /*
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    */
  }
  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === 1) {
      return 'by pressing ESC';
    } else if (reason === 0) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  openModalClasesUpdate(data: any, conten: string) {
    console.log(data);
    this.codClase = data.clase;
    this.codCodigoClase = data.codigo;
    this.spinnerService.activarLoading(true);
    this.contactoService.getListClasesContacto().subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      this.clasesCombo = response.body;
      console.log("editar modal")
      console.log( this.clasesCombo)
      console.log(this.codClase)
      this.getListCodigoClases(data.clase);
      this.NuevoModal(conten);
    }, err => {
      console.log(err);
      if (err.status == 404) {
        basicAlert(err.error, 'warning', 'Aceptar', null, null);
        this.spinnerService.activarLoading(false);
      }
    }) 
  }

  modificarClase() {
    this.ParamsContactoClases.codcli = this.codInterlocutor;
    this.ParamsContactoClases.codcont = this.contacto.codcont;
    this.ParamsContactoClases.clase = this.codClase;
    this.ParamsContactoClases.codigo = this.codCodigoClase;
    this.ParamsContactoClases.usuari = this.codUsuario;

    this.objContacto.codInterlocutor = this.codInterlocutor;
    this.objContacto.codContacto = this.contacto.codcont;

    console.log(this.ParamsContactoClases);
    this.spinnerService.activarLoading(true);
    this.interlocutorService.updateContactoClaseInterlocutor(this.codInterlocutor, this.contacto.codcont, this.ParamsContactoClases).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      let data: any = {
        codcont: this.contacto.codcont,
      }
      this.onClickDatosAdjunto(data)
      this.modalService.dismissAll();

      basicAlert('Se actualizo correctamente', 'success', 'Aceptar', null, null);
    }, err => {
      if (err.status == 409) {
        console.log(err);
        basicAlert(err.error, 'warning', 'Aceptar', null, null);
        this.spinnerService.activarLoading(false);
      } if (err.status == 400) {
        console.log(err);
        basicAlert(err.error, 'warning', 'Aceptar', null, null);
        this.spinnerService.activarLoading(false);
      } if (err.status == 500) {
        console.log(err);
        basicAlert(err.error, 'warning', 'Aceptar', null, null);
        this.spinnerService.activarLoading(false);
      }
    })
  }

  getListCodigoClases(clase: number) {
    this.spinnerService.activarLoading(true);

    this.contactoService.getListCodigosClaseContacto(clase).subscribe((response: any) => {
      console.log(response);
      this.claseCodigos = response.body;
      this.spinnerService.activarLoading(false);

    }, err => {
      console.log(err);
      if (err.status == 404) {
        basicAlert('No hay lista de códigos para la clase seleccionada', 'warning', 'Aceptar', null, null);
        this.spinnerService.activarLoading(false);
      }
    })
  }

  deleteContactoClaseCliente(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true).then((responseAlert) => {
      if (responseAlert) {
        this.spinnerService.activarLoading(true);
        timerOut(100).then((value: any) => {
          console.log(value);
          if (value) {
            console.log("Se Eliminará")
            console.log(data)
            this.interlocutorService.deleteContactoClaseInterlocutor(this.codInterlocutor, data.codcont, data.clase, data.codigo).subscribe((response: any) => {
              this.spinnerService.activarLoading(false);
              console.log("respuesta:");
              console.log(response);
              basicAlert('Se eliminó correctamente.', 'success', 'Aceptar');

              let data: any = {
                codcont: this.contacto.codcont,
              }
              this.onClickDatosAdjunto(data)

              this.getListContactos();
              this.borrarDatosContacto();
              //this.vista = 1
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err.error);
              basicAlert(err.error, 'success', 'Aceptar');
            });
          }
        });
      }
    }, err => {
      this.spinnerService.activarLoading(false);
    })
  }
  borrarDatosContacto() {
    this.objContacto = new objContactosFrm();
  }

  onClickDatosAdjunto(data: any) {
    this.interlocutorService.getGetByIdContactoInterlocutor(this.codInterlocutor, data.codcont).subscribe((response: any) => {
      console.log(response);
      this.contactoClases = response.body.clases;
    }, err => {
      console.log(err);
      if (err.status == 404) {
        this.spinnerService.activarLoading(false);
        basicAlert(err.error, 'warning', 'Aceptar', null, null);
      }
    })
  }

  getListContactos() {
    let nombres: string = '%';
    let activos: boolean = true;
    let limit: number = 60;
    let offset: number = 0;
    //this.vista = 1;
    this.spinnerService.activarLoading(true);
    this.contactoService.getContactoSearch(nombres, activos, limit, offset).subscribe((response: any) => {
      console.log(response);
      //this.contactos = response.body;
      this.spinnerService.activarLoading(false);
    }, err => {
      if (err.status == 404) {
        console.log(err);
        this.spinnerService.activarLoading(false);
        basicAlert('No se encontraron los contactos', 'error', 'Aceptar');
      }
    })
  }
 
  onChangeClases(clase: number) {
    console.log(clase);
    this.claseCodigos = [];
    this.getListCodigoClases(clase);
  }
  closeInsert(){
    this.ParamsContactoClases = new ContactoClase();
  }
  nuevaClase() {
    console.log('dttooss')
//console.log(this.codInterlocutormod)

    this.ParamsContactoClases.codcli = this.codInterlocutor;
    this.ParamsContactoClases.codcont = this.contacto.codcont
    this.ParamsContactoClases.clase = this.codClase;
    this.ParamsContactoClases.codigo = this.codCodigoClase;
    this.ParamsContactoClases.usuari = this.codUsuario;

    this.objContacto.codInterlocutor = this.codInterlocutor;
    this.objContacto.codContacto = this.contacto.codcont;
//console.log(this.codInterlocutormod +'--'+this.objContacto.codContacto +'--'+this.ParamsContactoClases)
    this.spinnerService.activarLoading(true);
    this.interlocutorService.insertContactoClaseInterlocutor(this.codInterlocutor, this.objContacto.codContacto, this.ParamsContactoClases).subscribe((response: any) => {
      console.log(response);
      this.borrarDatosInsert();
      basicAlert('Se registro correctamente', 'success', 'Aceptar', null, null);
      this.spinnerService.activarLoading(false);
      let data: any = {
        codcont: this.contacto.codcont,
      }
      this.onClickDatosAdjunto(data)
      this.modalReference.close();
    }, err => {
      if (err.status == 404) {
        console.log(err);
        basicAlert(err.error, 'warning', 'Aceptar', null, null);
        this.spinnerService.activarLoading(false);
      } if (err.status == 400) {
        console.log(err);
        basicAlert(err.error, 'warning', 'Aceptar', null, null);
        this.spinnerService.activarLoading(false);
      } if (err.status == 500) {
        console.log(err);
        basicAlert(err.error, 'warning', 'Aceptar', null, null);
        this.spinnerService.activarLoading(false);
      }
    })
  }

  borrarDatosInsert() {
    this.codClase = null;
    this.desClase = '';
    this.codCodigoClase = '';
    this.desCodigoClase = '';
  }
}
